import { createSlice, createEntityAdapter, Update } from '@reduxjs/toolkit'
import { Branch } from './typings'
import { StoreData } from '../reducers/typings'
import { getBranchList, getBranchDetail } from './api'

const branchAdapter = createEntityAdapter<Branch>({
  selectId: (b) => b.id,
})

export const initialState = branchAdapter.getInitialState()

export const branches = createSlice({
  name: 'branches',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getBranchList.fulfilled, (state, { payload }) => {
      const toAdd = payload.map((b) => ({ ...b, loaded: false }))
      branchAdapter.addMany(state, toAdd)
    })
    builder.addCase(getBranchDetail.fulfilled, (state, { payload }) => {
      const update: Update<Branch> = {
        id: payload.id,
        changes: {
          ...payload,
          loaded: true,
        },
      }
      branchAdapter.updateOne(state, update)
    })
  },
})

export default branches.reducer

export const branchAdapterSelectors = branchAdapter.getSelectors<StoreData>(
  (state) => state.branches,
)

export const { selectById: selectBranchById, selectAll: selectAllBranches } =
  branchAdapterSelectors
